import './page-not-found.scss';
